import { AxiosInstance } from 'axios'

import {
  userApiDefaultApiFactory,
  // Do Not Remove this line ===@import api type===
} from '@src/api/default-api-factories'

export const getUserAccountYearMonthSummary = async (
  instance: AxiosInstance,
  organizationId: string,
  fromYearMonth: string | undefined,
  toYearMonth: string
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getUserAccountYearMonthSummary({
    fromYearMonth,
    organizationId,
    toYearMonth,
  })
}

// Do Not Remove this line ===@import api client===
